import { TRecommendation } from '../../types/recommendation';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ENotAvailableModalTypes {
  Open = 'notAvailableModal/open',
  Close = 'notAvailableModal/close',
}

export type TOpenNotAvailableModalPayload = { offer: TRecommendation; phone: string };

export type TOpenNotAvailableModal = ITypedReduxAction<ENotAvailableModalTypes.Open, TOpenNotAvailableModalPayload>;
export type TCloseNotAvailableModal = ITypedReduxAction<ENotAvailableModalTypes.Close>;

export type TNotAvailableModalActions = TOpenNotAvailableModal | TCloseNotAvailableModal;
